import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';

///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { ModalComponent } from "./modal/modal.component";

export interface getProductos{
  productos: Product[]
}
export interface Product {
  idProducto: number;
  nombreProducto: string;
}

@Component({
  selector: 'app-paquete',
  templateUrl: './paquete.component.html',
  styleUrls: ['./paquete.component.scss'],
  animations : fuseAnimations
})
export class PaqueteComponent implements OnInit {

  productosContratadosInter : backInter.infoProductos;
  listaProductos: getProductos;
  instituto: number = 0;
  enterpriseData : any;
  nombreEmpresa : string;
  sectorName : string;
  subsectorName : string;
  rankingName : string;
  tipoName : string;
  aplicaRanking:any;
  idEmpresa: string;

  anioActual: number;
  paqueteActual: backInter.prodPaquete;

  //SET DE IDS DE PRODUCTOS MINIMOS
  OK_certificar: string;
  idResultadosGlobal: string;
  idResultados4All: string;
  OK_ca = 0;
  //IDS ORO
  idResultadosCompleto: string;
  //IDS PLATINO
  //ids de productos medir, pulse, etc
  OK_resultados: boolean;

  arrayIdProductos: any[] = [];

  porcentajeAvance = 0;

  restoProds:boolean;

  constructor(
    private activatedRoute : ActivatedRoute,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private dialog: MatDialog,
    private odsService: ODSService,
  ) {
    this.anioActual = new Date().getFullYear();
    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
      this.getEnterpriseDetail(this.idEmpresa);
      // this.getProductsByCompany();
      // this.getYears();
      // this.getEstilos();
    });
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.getListaProductos();
    this.getProductosEmpresa();
  }

  calculaAvance(){
    this.porcentajeAvance = 0;
    if(this.OK_certificar) this.porcentajeAvance++;
    if(this.idResultadosGlobal) this.porcentajeAvance++;
    if(this.idResultados4All) this.porcentajeAvance++;
    if(this.idResultadosCompleto) this.porcentajeAvance++;
    this.porcentajeAvance += (this.OK_ca * 0.5);
    if(this.paqueteActual.tipo == 1){
      this.porcentajeAvance = (this.porcentajeAvance / 4) * 100;
      if(this.idResultadosGlobal && this.idResultados4All){
        this.OK_resultados = true;
      }
    }
    else{
      this.porcentajeAvance = (this.porcentajeAvance / 5) * 100;
      if(this.idResultadosGlobal && this.idResultados4All && this.idResultadosCompleto){
        this.OK_resultados = true;
      }
    }
    console.log(this.porcentajeAvance);

  }

  getEnterpriseDetail(idEnterprise : string) {
    this.odsService.getEnterpriseDetail(idEnterprise)
    .subscribe(response => {
      console.log("getEnterpriseDeailt");
      console.log(response);
      this.aplicaRanking=response['data']['ranking'];

      this.enterpriseData = response['data'];
      this.instituto = response['data']['institutoEmpresa'];

      this.nombreEmpresa = this.enterpriseData['nombreEmpresa'];
      this.sectorName = this.enterpriseData['sector'];
      this.subsectorName = this.enterpriseData['subSector'];
      this.rankingName = this.enterpriseData['tipo'];
      this.tipoName = this.enterpriseData['tipo'];

      // this.getPlantillas(this.enterpriseData['institutoEmpresa']);

      // this.getProducts();
    }, error => {
      console.log("error", error);
    });
  }

  muestraRestoProds(){
    this.restoProds = !this.restoProds;
  }

  getListaProductos(){
    this.odsService.getProductsArray().subscribe((respuesta: getProductos) => {
      console.log("Respuestas");
      console.log(respuesta);
      this.listaProductos = respuesta;
    });
  }

  getProductosEmpresa() {
    this.odsService.getProductosEmpresa(this.idEmpresa).subscribe((respuesta:backInter.infoProductos) => {
      console.log("getProdsEmp:",respuesta);
      this.productosContratadosInter = respuesta;
      this.ordenaProductosPaquetes(this.productosContratadosInter.paquetes);
      // this.filtraProductosMedir();
    }, error => {
      console.log("error", error);
    })
  }

  // filtraProductosPaquetes(){
  //   this.productosContratadosInter.productosSilver.forEach((producto:backInter.prodPaquete) => {
  //     // if()
  //   });
  // }

  ordenaProductosPaquetes(paquetes: backInter.prodPaquete[]){
    paquetes.sort( (a,b) => {
      if(a.fecha > b.fecha){
        return 1;
      } else{
        return -1;
      }
    });
    this.productosContratadosInter.paquetes = paquetes;

    this.arrayIdProductos = [];
    var BreakException = {};
    try {
      this.productosContratadosInter.paquetes.forEach((paquete: backInter.prodPaquete) => {
        if(paquete.fecha == this.anioActual){
          this.paqueteActual = paquete;
          if(this.paqueteActual.productos){
            this.paqueteActual.productos.forEach((producto: any) => {
              // if(producto.certificar) this.OK_certificar = producto.certificar;
              if(producto.certificar){
                let clave:number;
                if(producto.tipo == 1) clave = 1;
                if(producto.tipo == 2) clave = 20;
                this.arrayIdProductos.push({nombre:"certificar", id: producto.certificar, clave});
                this.OK_certificar = producto.certificar;
              }
              if(producto.cultureAuditV2){
                let clave:number;
                switch (producto.tipo) {
                  case 1: clave = 9; break;
                  case 4: clave = 30; break;
                  case 5: clave = 31; break;
                  case 6: clave = 32; break;
                  case 7: clave = 33; break;
                }
                this.arrayIdProductos.push({nombre:"cav2", id: producto.cultureAuditV2, clave});
                if(this.OK_ca < 2) this.OK_ca++;
              }
              if(producto.cultureAuditTR){
                this.arrayIdProductos.push({nombre:"catr", id: producto.cultureAuditTR, clave: 10});
                if(this.OK_ca < 2) this.OK_ca++;
              }
              if(producto.resultadosGlobales){
                this.arrayIdProductos.push({nombre:"res_globales", id: producto.resultadosGlobales, clave: 21});
                this.idResultadosGlobal = producto.resultadosGlobales;
              }
              if(producto.resultadosSencillos4ALL){
                this.arrayIdProductos.push({nombre:"res_4all", id: producto.resultadosSencillos4ALL, clave: 22});
                this.idResultados4All = producto.resultadosSencillos4ALL;
              }
              if(producto.resultadosCompletos){
                this.arrayIdProductos.push({nombre:"res_completos", id: producto.resultadosCompletos, clave: 23});
                this.idResultadosCompleto = producto.resultadosCompletos;
              }
              if(producto.medir){
                let clave:number;
                switch (producto.tipo) {
                  case 0: clave = 2; break;
                  case 1: clave = 11; break;
                  case 2: clave = 12; break;
                  case 3: clave = 13; break;
                  case 4: clave = 14; break;
                  case 5: clave = 15; break;
                  case 6: clave = 16; break;
                }
                this.arrayIdProductos.push({nombre:"medir", id: producto.medir, clave});
              }
              if(producto.pulseCheck){
                this.arrayIdProductos.push({nombre:"pulse", id: producto.pulseCheck, clave: 4});
              }
              if(producto.focusArea){
                this.arrayIdProductos.push({nombre:"focus", id: producto.focusArea, clave: 6});
              }
              if(producto.norma35){
                let clave:number;
                if(producto.tipo == 1) clave = 3;
                if(producto.tipo == 2) clave = 19;
                this.arrayIdProductos.push({nombre:"nom35", id: producto.norma35, clave});
              }
            });
          }
          this.calculaAvance();
          throw BreakException;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };

    console.log("despues de ordenamiento");
    console.log(this.productosContratadosInter);


  }

  agregaPaquete(){
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '70%',
      data: {
        formulario: "paquete",
        productos: this.listaProductos,
        idEmpresa: this.idEmpresa
      }
    });

    dialogRef.afterClosed().subscribe((resultado?:any) => {
      // console.log('The dialog was closed');
      // this.animal = result;
      if(resultado){
        console.log(resultado);
        this.getProductosEmpresa()
      }
    });
  }

  agregaProducto(numProducto:number,tipoForm:string, nomProducto?:string){
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '70%',
      data: {
        formulario: tipoForm,
        productos: this.listaProductos,
        idEmpresa: this.idEmpresa,
        instituto: this.instituto,
        anio: this.paqueteActual.fecha,
        paqueteId: this.paqueteActual._id,
        tipoPaquete: this.paqueteActual.tipo,
        numProducto,
        idsProductos: this.filtraIdsProductos(nomProducto),
        productosEmpresa: this.productosContratadosInter
      }
    });

    dialogRef.afterClosed().subscribe((resultado?:any) => {
      // console.log('The dialog was closed');
      // this.animal = result;
      if(resultado){
        console.log(resultado);
        this.getProductosEmpresa()
      }
    });
  }

  filtraIdsProductos(nomProducto:string){
    let arreglo: any[] = [];
    this.arrayIdProductos.forEach((infoProducto:any) => {
      switch (nomProducto) {
        case "certificar":
          if(infoProducto.nombre == "certificar")
            arreglo.push(infoProducto);
        break;
        case "cultureaudit":
          if(infoProducto.nombre == "cav2" || infoProducto.nombre == "catr")
            arreglo.push(infoProducto);
        break;
        case "resultados":
          if(infoProducto.nombre == "res_globales" || infoProducto.nombre == "res_completos" || infoProducto.nombre == "res_4all")
            arreglo.push(infoProducto);
        break;
        case "medir":
          if(infoProducto.nombre == "medir")
            arreglo.push(infoProducto);
        break;
        case "pulse":
          if(infoProducto.nombre == "pulse")
            arreglo.push(infoProducto);
        break;
        case "focus":
          if(infoProducto.nombre == "focus")
            arreglo.push(infoProducto);
        break;
        case "nom35":
          if(infoProducto.nombre == "nom35")
            arreglo.push(infoProducto);
        break;
      }
    });
    return arreglo;
  }

}
